/**
 * Typed Auth-Endpoints. Sobald `pnpm api:types` läuft, ersetzen wir die
 * handgeschriebenen Schemas hier durch die generierten aus
 * `@/api/generated/schema`.
 */
import { api } from "@/api/client";

export interface LoginRequest {
  email: string;
  password: string;
}

export interface TokenResponse {
  access_token: string;
  token_type: "bearer";
  expires_in: number;
}

export type UserRole = "admin" | "owner" | "member";
export type UserStatus = "active" | "invited" | "disabled";

export interface UserResponse {
  id: string;
  tenant_id: string | null;
  email: string;
  full_name: string;
  role: UserRole;
  status: UserStatus;
  locale: string;
}

export async function login(payload: LoginRequest): Promise<TokenResponse> {
  const { data } = await api.post<TokenResponse>("/v1/auth/login", payload);
  return data;
}

export async function logout(): Promise<void> {
  await api.post("/v1/auth/logout");
}

export async function getCurrentUser(): Promise<UserResponse> {
  const { data } = await api.get<UserResponse>("/v1/auth/me");
  return data;
}
